import {
  STORES_LIST,
  STORE_ADD,
  STORE_EDIT,
  STORE_DELETE,
  STORE_DETAILS,
} from "../constants/api-path";
import httpClient from "./http.interceptor";

/**
 * @param {page: number, limit: number, sortColumn: string|number, sortDirection: string } formData
 * @returns Promise<any>
 */
export const getAppStores = (formData: any): Promise<any> => {
  return httpClient.get(STORES_LIST, {
    params: {
      page: formData.page,
      pageSize: formData.limit,
      sort: formData.sort,
      search: formData.search,
      country_id: formData.country_id,
      province_id: formData.province_id,
      city_id: formData.city_id,
      dropdown: formData.dropdown,
      for_update: formData.for_update,
    },
  });
};

/**
 * @param {formData: any } params
 * @returns Promise<any>
 */
export const addAppStore = (formData: any): Promise<any> => {
  return httpClient.post(STORE_ADD, formData);
};

/**
 * @param {id: string formData: any } params
 * @returns Promise<any>
 */
export const editAppStore = (id: string, formData: any): Promise<any> => {
  return httpClient.put(STORE_EDIT + id, formData);
};

/**
 * @param {id: string } params
 * @returns Promise<any>
 */
export const deleteAppStore = (id: string | number): Promise<any> => {
  return httpClient.delete(STORE_DELETE + id);
};

/**
 * @param {id: string } params
 * @returns Promise<any>
 */
export const getAppStoreDetails = (id: string | number): Promise<any> => {
  return httpClient.get(STORE_DETAILS + id);
};
